import React from 'react';
import { useCustomRequestFormMap } from './CustomRequestFormMapContext';
import { CustomForm } from 'domain/shared/oneStop';
import { CustomRequestFormType } from './types';

type CustomRequestFormFactoryProps = {
  form: Nullable<CustomForm>;
  openModal: (content: any, title?: string) => void;
  requestId?: string;
  props?: any;
};

const CustomRequestFormFactory = ({ form, ...props }: CustomRequestFormFactoryProps) => {
  const formMap = useCustomRequestFormMap();

  if (!form) {
    return null;
  }

  const Form: CustomRequestFormType = formMap[form];

  return <Form {...props} />;
};

export default CustomRequestFormFactory;
